module.exports = __webpack_public_path__ + "static/img/quadrante_mama.d1dd70f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/quadrante_mama.png
// module id = 3daF
// module chunks = 1